/* eslint-disable */
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';
import type { RoomPeople } from '../module/yanolja_standardcode/room-people';

/**
 * PageName: TRANSPORTATION_HOME    */
export const TransportationHomePageLog = {
  QuickCategoryBoardRowItem: {
    /**
     * 교통 서브홈 - 퀵카테고리 - 노출
     * 참고: https://screen.yanolja.in/lA8ilsCrrQJNlb1c
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L4}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    impression({ widgetPosition, position }: TransportationHomePageLog.QuickCategoryBoardRowItem.Impression) {
      return KinesisTracker.impression('TRANSPORTATION_HOME', {
        clientEventId: 336,
        pageName: 'PAGE_NAME_TRANSPORTATION_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_IMPR',
        widgetPosition,
        position,
      });
    },

    /**
     * 교통 서브홈 - 퀵카테고리 - 클릭
     * 참고: https://screen.yanolja.in/lA8ilsCrrQJNlb1c
     *#### 날짜 및 인원 선택 bottom sheet 시작 #####
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L16}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    click({ widgetPosition, position }: TransportationHomePageLog.QuickCategoryBoardRowItem.Click) {
      return KinesisTracker.click('TRANSPORTATION_HOME', {
        clientEventId: 100,
        pageName: 'PAGE_NAME_TRANSPORTATION_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_CLICK',
        widgetPosition,
        position,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace TransportationHomePageLog {
  export namespace QuickCategoryBoardRowItem {
    /**
     * 참고: https://screen.yanolja.in/lA8ilsCrrQJNlb1c
     */
    export interface Impression {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
    }

    /**
     * 참고: https://screen.yanolja.in/lA8ilsCrrQJNlb1c
     *#### 날짜 및 인원 선택 bottom sheet 시작 #####
     */
    export interface Click {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
    }
  }
}

/**
 * PageName: EXBUS_HOME
 */
export const ExbusHomePageLog = {
  CheckInOutDateAndSetPeopleButton: {
    /**
     * 서브홈(고속버스) - bottom sheet 내에서 체크인아웃 날짜 클릭
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L31}
     */
    click({}: ExbusHomePageLog.CheckInOutDateAndSetPeopleButton.Click = {}) {
      return KinesisTracker.click('EXBUS_HOME', {
        clientEventId: 539,
        pageName: 'PAGE_NAME_EXBUS_HOME',
        object: 'checkInOutDate',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  CheckInOutDateAndSetPeopleButtonClass: {
    /**
     * 서브홈(고속버스) - bottom sheet 내에서 등급 변경 클릭
     * https://screen.yanolja.in/QhArO4nxDmIahCuk
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L42}
     */
    click({}: ExbusHomePageLog.CheckInOutDateAndSetPeopleButtonClass.Click = {}) {
      return KinesisTracker.click('EXBUS_HOME', {
        clientEventId: 540,
        pageName: 'PAGE_NAME_EXBUS_HOME',
        object: 'setClass',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  CheckInOutDateAndSetPeopleLabelChange: {
    /**
     * 서브홈(고속버스) - 날짜 변경 완료 (설정 후 확인 클릭 시, 변경된 날짜 로깅)
     * https://screen.yanolja.in/FERmFZRzGq3j7CZh.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L53}
     * CheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L73}
     */
    bg({
      checkInDate,
      checkOutDate,
      roomPeople,
      exbusClass,
    }: ExbusHomePageLog.CheckInOutDateAndSetPeopleLabelChange.Bg) {
      return KinesisTracker.bg('EXBUS_HOME', {
        clientEventId: 541,
        pageName: 'PAGE_NAME_EXBUS_HOME',
        object: 'changeCheckInOutDate',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_BG',
        checkInDate,
        checkOutDate,
        roomPeople,
        exbusClass,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace ExbusHomePageLog {
  export namespace CheckInOutDateAndSetPeopleButton {
    /**
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     */
    export interface Click {}
  }
  export namespace CheckInOutDateAndSetPeopleButtonClass {
    /**
     * https://screen.yanolja.in/QhArO4nxDmIahCuk
     */
    export interface Click {}
  }
  export namespace CheckInOutDateAndSetPeopleLabelChange {
    /**
     * https://screen.yanolja.in/FERmFZRzGq3j7CZh.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     */
    export interface Bg {
      /* 바텀싯관련 정보 - &lt;날짜 변경 완료 bg 로그&gt; 에만 추가*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* 객실 정보.*/
      roomPeople?: RoomPeople[];
      /* 버스 등급 ex) 전체, 프리미엄, 우등, 일반... 심야프리미엄... 등*/
      exbusClass?: string;
    }
  }
}

/**
 * PageName: TRAIN_HOME
 */
export const TrainHomePageLog = {
  CheckInOutDateAndSetPeopleButton: {
    /**
     * 서브홈(기차) - bottom sheet 내에서 체크인아웃 날짜 클릭
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L65}
     */
    click({}: TrainHomePageLog.CheckInOutDateAndSetPeopleButton.Click = {}) {
      return KinesisTracker.click('TRAIN_HOME', {
        clientEventId: 542,
        pageName: 'PAGE_NAME_TRAIN_HOME',
        object: 'checkInOutDate',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  CheckInOutDateAndSetPeopleButton543: {
    /**
     * 서브홈(기차) - bottom sheet 내에서 인원 변경 클릭
     * https://screen.yanolja.in/Tj1unrmf5bJs36lU.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L76}
     */
    click({}: TrainHomePageLog.CheckInOutDateAndSetPeopleButton543.Click = {}) {
      return KinesisTracker.click('TRAIN_HOME', {
        clientEventId: 543,
        pageName: 'PAGE_NAME_TRAIN_HOME',
        object: 'setPeople',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  CheckInOutDateAndSetPeopleLabelChange: {
    /**
     * 서브홈(기차) - 날짜 변경 완료 (설정 후 확인 클릭 시, 변경된 날짜 로깅)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/transportation/common.txtpb#L87}
     * CheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L73}
     */
    bg({
      checkInDate,
      checkOutDate,
      roomPeople,
      exbusClass,
    }: TrainHomePageLog.CheckInOutDateAndSetPeopleLabelChange.Bg) {
      return KinesisTracker.bg('TRAIN_HOME', {
        clientEventId: 544,
        pageName: 'PAGE_NAME_TRAIN_HOME',
        object: 'changeCheckInOutDate',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_BG',
        checkInDate,
        checkOutDate,
        roomPeople,
        exbusClass,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace TrainHomePageLog {
  export namespace CheckInOutDateAndSetPeopleButton {
    /**
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     */
    export interface Click {}
  }
  export namespace CheckInOutDateAndSetPeopleButton543 {
    /**
     * https://screen.yanolja.in/Tj1unrmf5bJs36lU.png
     */
    export interface Click {}
  }
  export namespace CheckInOutDateAndSetPeopleLabelChange {
    /**
     */
    export interface Bg {
      /* 바텀싯관련 정보 - &lt;날짜 변경 완료 bg 로그&gt; 에만 추가*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* 객실 정보.*/
      roomPeople?: RoomPeople[];
      /* 버스 등급 ex) 전체, 프리미엄, 우등, 일반... 심야프리미엄... 등*/
      exbusClass?: string;
    }
  }
}
